import styled from "@emotion/styled"
import Clutch from "components/Icons/Clutch"
import { css } from "@emotion/react"

const dynamicStyles = ({ theme }) => css`
  ${`
        ${theme.breakpoints.down("lg")} {
            width: 64px;
            height: 64px;
            margin-bottom: 20px;
        }

        ${theme.breakpoints.up("lg")} {
            width: 48px;
            height: 48px;
            margin-bottom: 20px;
        }

        ${theme.breakpoints.down("md")} {
            width: 48px;
            height: 48px;
            margin-bottom: 0px;
        }
    `}
`
const HeroScrollClutchIcon = styled(Clutch)`
  ${dynamicStyles}
`

export default HeroScrollClutchIcon
